// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ParentAuthRouteImport } from './routes/parent-auth'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as WidgetRouteImport } from './routes/widget'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAiRouteImport } from './routes/_app/ai'
import { Route as AppBreaksRouteImport } from './routes/_app/breaks'
import { Route as AppClassesRouteImport } from './routes/_app/classes'
import { Route as AppCommunityRouteImport } from './routes/_app/community'
import { Route as AppDiagnosticsRouteImport } from './routes/_app/diagnostics'
import { Route as AppExploreRouteImport } from './routes/_app/explore'
import { Route as AppFamilyRouteImport } from './routes/_app/family'
import { Route as AppFlashcardsRouteImport } from './routes/_app/flashcards'
import { Route as AppLearnRouteImport } from './routes/_app/learn'
import { Route as AppPlannerRouteImport } from './routes/_app/planner'
import { Route as AppPrepRouteImport } from './routes/_app/prep'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppProfilesRouteImport } from './routes/_app/profiles'
import { Route as AppProgramsRouteImport } from './routes/_app/programs'
import { Route as AppQuizRouteImport } from './routes/_app/quiz'
import { Route as AppRewardsRouteImport } from './routes/_app/rewards'
import { Route as AppStatsRouteImport } from './routes/_app/stats'
import { Route as AppStudioRouteImport } from './routes/_app/studio'
import { Route as AppTeacherRouteImport } from './routes/_app/teacher'
import { Route as AppTeacherHubRouteImport } from './routes/_app/teacher-hub'
import { Route as AppTeacherResultsRouteImport } from './routes/_app/teacher-results'
import { Route as AppTeachingStudioRouteImport } from './routes/_app/teaching-studio'
import { Route as AppToolsRouteImport } from './routes/_app/tools'
import { Route as AppBreaksIndexRouteImport } from './routes/_app/breaks.index'
import { Route as AppBreaksPeriodIdRouteImport } from './routes/_app/breaks.$periodId'
import { Route as AppClassClassIdRouteImport } from './routes/_app/class.$classId'
import { Route as AppProgramsIndexRouteImport } from './routes/_app/programs.index'
import { Route as AppProgramsCurriculumIdRouteImport } from './routes/_app/programs.$curriculumId'
import { Route as AppStudentIdRouteImport } from './routes/_app/student.$id'
import { Route as AppProgramsCurriculumIdIndexRouteImport } from './routes/_app/programs.$curriculumId.index'
import { Route as AppProgramsCurriculumIdTopicIdRouteImport } from './routes/_app/programs.$curriculumId.$topicId'

const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const ParentAuthRoute = ParentAuthRouteImport.update({
            id: '/parent-auth',path: '/parent-auth',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const WidgetRoute = WidgetRouteImport.update({
            id: '/widget',path: '/widget',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRouteRoute
          })
const AppAiRoute = AppAiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => AppRouteRoute
          })
const AppBreaksRoute = AppBreaksRouteImport.update({
            id: '/breaks',path: '/breaks',getParentRoute: () => AppRouteRoute
          })
const AppClassesRoute = AppClassesRouteImport.update({
            id: '/classes',path: '/classes',getParentRoute: () => AppRouteRoute
          })
const AppCommunityRoute = AppCommunityRouteImport.update({
            id: '/community',path: '/community',getParentRoute: () => AppRouteRoute
          })
const AppDiagnosticsRoute = AppDiagnosticsRouteImport.update({
            id: '/diagnostics',path: '/diagnostics',getParentRoute: () => AppRouteRoute
          })
const AppExploreRoute = AppExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => AppRouteRoute
          })
const AppFamilyRoute = AppFamilyRouteImport.update({
            id: '/family',path: '/family',getParentRoute: () => AppRouteRoute
          })
const AppFlashcardsRoute = AppFlashcardsRouteImport.update({
            id: '/flashcards',path: '/flashcards',getParentRoute: () => AppRouteRoute
          })
const AppLearnRoute = AppLearnRouteImport.update({
            id: '/learn',path: '/learn',getParentRoute: () => AppRouteRoute
          })
const AppPlannerRoute = AppPlannerRouteImport.update({
            id: '/planner',path: '/planner',getParentRoute: () => AppRouteRoute
          })
const AppPrepRoute = AppPrepRouteImport.update({
            id: '/prep',path: '/prep',getParentRoute: () => AppRouteRoute
          })
const AppProfileRoute = AppProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppRouteRoute
          })
const AppProfilesRoute = AppProfilesRouteImport.update({
            id: '/profiles',path: '/profiles',getParentRoute: () => AppRouteRoute
          })
const AppProgramsRoute = AppProgramsRouteImport.update({
            id: '/programs',path: '/programs',getParentRoute: () => AppRouteRoute
          })
const AppQuizRoute = AppQuizRouteImport.update({
            id: '/quiz',path: '/quiz',getParentRoute: () => AppRouteRoute
          })
const AppRewardsRoute = AppRewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => AppRouteRoute
          })
const AppStatsRoute = AppStatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => AppRouteRoute
          })
const AppStudioRoute = AppStudioRouteImport.update({
            id: '/studio',path: '/studio',getParentRoute: () => AppRouteRoute
          })
const AppTeacherRoute = AppTeacherRouteImport.update({
            id: '/teacher',path: '/teacher',getParentRoute: () => AppRouteRoute
          })
const AppTeacherHubRoute = AppTeacherHubRouteImport.update({
            id: '/teacher-hub',path: '/teacher-hub',getParentRoute: () => AppRouteRoute
          })
const AppTeacherResultsRoute = AppTeacherResultsRouteImport.update({
            id: '/teacher-results',path: '/teacher-results',getParentRoute: () => AppRouteRoute
          })
const AppTeachingStudioRoute = AppTeachingStudioRouteImport.update({
            id: '/teaching-studio',path: '/teaching-studio',getParentRoute: () => AppRouteRoute
          })
const AppToolsRoute = AppToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => AppRouteRoute
          })
const AppBreaksIndexRoute = AppBreaksIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppBreaksRoute
          })
const AppBreaksPeriodIdRoute = AppBreaksPeriodIdRouteImport.update({
            id: '/$periodId',path: '/$periodId',getParentRoute: () => AppBreaksRoute
          })
const AppClassClassIdRoute = AppClassClassIdRouteImport.update({
            id: '/class/$classId',path: '/class/$classId',getParentRoute: () => AppRouteRoute
          })
const AppProgramsIndexRoute = AppProgramsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppProgramsRoute
          })
const AppProgramsCurriculumIdRoute = AppProgramsCurriculumIdRouteImport.update({
            id: '/$curriculumId',path: '/$curriculumId',getParentRoute: () => AppProgramsRoute
          })
const AppStudentIdRoute = AppStudentIdRouteImport.update({
            id: '/student/$id',path: '/student/$id',getParentRoute: () => AppRouteRoute
          })
const AppProgramsCurriculumIdIndexRoute = AppProgramsCurriculumIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppProgramsCurriculumIdRoute
          })
const AppProgramsCurriculumIdTopicIdRoute = AppProgramsCurriculumIdTopicIdRouteImport.update({
            id: '/$topicId',path: '/$topicId',getParentRoute: () => AppProgramsCurriculumIdRoute
          })





const AppBreaksRouteChildren = {
  AppBreaksPeriodIdRoute: AppBreaksPeriodIdRoute,AppBreaksIndexRoute: AppBreaksIndexRoute
}

const AppBreaksRouteWithChildren = AppBreaksRoute._addFileChildren(AppBreaksRouteChildren)




const AppProgramsCurriculumIdRouteChildren = {
  AppProgramsCurriculumIdTopicIdRoute: AppProgramsCurriculumIdTopicIdRoute,AppProgramsCurriculumIdIndexRoute: AppProgramsCurriculumIdIndexRoute
}

const AppProgramsCurriculumIdRouteWithChildren = AppProgramsCurriculumIdRoute._addFileChildren(AppProgramsCurriculumIdRouteChildren)



const AppProgramsRouteChildren = {
  AppProgramsCurriculumIdRoute: AppProgramsCurriculumIdRouteWithChildren,AppProgramsIndexRoute: AppProgramsIndexRoute
}

const AppProgramsRouteWithChildren = AppProgramsRoute._addFileChildren(AppProgramsRouteChildren)



const AppRouteRouteChildren = {
  AppAiRoute: AppAiRoute,AppBreaksRoute: AppBreaksRouteWithChildren,AppClassesRoute: AppClassesRoute,AppCommunityRoute: AppCommunityRoute,AppDiagnosticsRoute: AppDiagnosticsRoute,AppExploreRoute: AppExploreRoute,AppFamilyRoute: AppFamilyRoute,AppFlashcardsRoute: AppFlashcardsRoute,AppLearnRoute: AppLearnRoute,AppPlannerRoute: AppPlannerRoute,AppPrepRoute: AppPrepRoute,AppProfileRoute: AppProfileRoute,AppProfilesRoute: AppProfilesRoute,AppProgramsRoute: AppProgramsRouteWithChildren,AppQuizRoute: AppQuizRoute,AppRewardsRoute: AppRewardsRoute,AppStatsRoute: AppStatsRoute,AppStudioRoute: AppStudioRoute,AppTeacherRoute: AppTeacherRoute,AppTeacherHubRoute: AppTeacherHubRoute,AppTeacherResultsRoute: AppTeacherResultsRoute,AppTeachingStudioRoute: AppTeachingStudioRoute,AppToolsRoute: AppToolsRoute,AppIndexRoute: AppIndexRoute,AppClassClassIdRoute: AppClassClassIdRoute,AppStudentIdRoute: AppStudentIdRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)

const rootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,AuthRoute: AuthRoute,OnboardingRoute: OnboardingRoute,ParentAuthRoute: ParentAuthRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,WidgetRoute: WidgetRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)